/** @jsxImportSource @emotion/react */
import {Dialog} from '@reach/dialog';
import Img from './ResetSuccess.svg';
import {IconButton} from '../../../../components/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

type ResetDialogProps = {
  onCancel?: () => void;
  isOpen?: boolean;
};

export default function ResetSuccessDialog({
  onCancel,
  isOpen,
}: ResetDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      css={{width: 361, height: 251}}
      aria-label="reset-success-dialog"
    >
      <IconButton
        onClick={onCancel}
        css={{float: 'right'}}
        data-test-id={'close-btn'}
        aria-label={'close-btn'}
      >
        <div css={{'& > svg': {fontSize: '18px !important'}}}>
          <FontAwesomeIcon icon={['fal', 'times']} />
        </div>
      </IconButton>
      <div
        css={{
          margin: '38px auto 50px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h3 css={{fontSize: 18}}>重設成功</h3>
        <img src={Img} alt="resetSuccessImg" />
      </div>
    </Dialog>
  );
}
